import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem } from '@bonusly/design-system';

interface AttachmentModalProps {
	isOpen: boolean;
	onClose: () => void;
	url: string;
}

const AttachmentModal: FC<AttachmentModalProps> = ({ isOpen, onClose, url }) => {
	const { t } = useTranslation('admin', {
		keyPrefix: 'incentives.summary',
	});

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="3xl">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader borderBottomWidth={rem(1)} borderColor="border.default" borderStyle="solid" color="text.default">
					{t('preview_modal_header')}
				</ModalHeader>
				<ModalCloseButton size="lg" borderRadius="full" />
				<ModalBody py={4} px={6}>
					<Image src={url} w="auto" maxH="78vh" margin="0 auto" />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export { AttachmentModal };
